import { ChevronRightRounded as ChevronRightRoundedIcon, LogoutRounded as LogoutRoundedIcon } from '@mui/icons-material'
import { Divider, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material'
import { t } from 'i18next'
import { Link, useLocation, useNavigate } from 'react-router-dom'

import { useAuth } from '../../Shared/Contexts/AuthContext.jsx'
import { useGlobalContext } from '../../Shared/Contexts/GlobalContext.jsx'

export default function ProfileMenu({ anchorEl, isOpen, handleClose }) {
  const { openSuccessAlert } = useGlobalContext()
  const { pathname } = useLocation()
  const navigate = useNavigate()

  const {
    authState: { refreshToken },
    logout,
    refreshSelfOrganizations
  } = useAuth()

  const { useLogoutUser } = useAuth()

  const handleManagementNavigation = () => {
    if (pathname === '/management' || pathname.startsWith('/management/')) {
      refreshSelfOrganizations()
    }
  }

  const handleLogout = () => {
    useLogoutUser({ refreshToken })
      .then(() => {
        openSuccessAlert()
        logout()
      })
      .catch(() => logout())
      .finally(() => navigate('/'))
  }

  return (
    <Menu
      anchorEl={anchorEl}
      open={isOpen}
      onClose={handleClose}
      onClick={handleClose}
      transformOrigin={{
        horizontal: 'right',
        vertical: 'top'
      }}
      anchorOrigin={{
        horizontal: 'right',
        vertical: 'bottom'
      }}
      sx={{ top: '20px' }}>
      <MenuItem
        id="profile-menu-profile"
        component={Link}
        onClick={handleManagementNavigation}
        to="/management/profile">
        <ListItemIcon>
          <ChevronRightRoundedIcon />
        </ListItemIcon>
        <ListItemText>{t('common.profile')}</ListItemText>
      </MenuItem>
      {
        //TODO: scommentare una volta che esiste la dashboard
        /* <MenuItem> 
        <ListItemIcon>
          <ChevronRightRoundedIcon />
        </ListItemIcon>
        <ListItemText>{t('common.dashboard')}</ListItemText>
      </MenuItem> */
      }
      <MenuItem
        id="profile-menu-management"
        component={Link}
        onClick={handleManagementNavigation}
        to={`/management/devices${window.location.search}`}>
        <ListItemIcon>
          <ChevronRightRoundedIcon />
        </ListItemIcon>
        <ListItemText>{t('common.management')}</ListItemText>
      </MenuItem>
      <Divider />
      <MenuItem
        id="profile-menu-logout"
        onClick={handleLogout}>
        <ListItemIcon>
          <LogoutRoundedIcon />
        </ListItemIcon>
        <ListItemText>{t('common.logout')}</ListItemText>
      </MenuItem>
    </Menu>
  )
}
